<template>
  <div class="nav-items d-flex flex-column flex-md-row justify-center text-4">
    <router-link
      v-for="(item, index) in menuItems"
      :key="item.name"
      :to="{ name: item.disabled ? $route.name : item.name }"
      :class="['text-decoration-none nav-item', { 'ml-md-10 mt-3 mt-md-0': index > 0 }]"
      :disabled="item.disabled"
      >{{ item.text }}</router-link
    >
  </div>
</template>

<script>
export default {
  data: () => ({
    menuItems: [
      {
        name: "Yield",
        text: "Explore",
      },
      {
        name: "Stats",
        text: "Stats",
      },
      {
        name: "Portfolio",
        text: "Portfolio",
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
.nav-items {
  .nav-item {
    &:not(.router-link-active) {
      color: var(--darkgray) !important;
    }
    &[disabled] {
      opacity: 0.2;
      cursor: not-allowed;
      color: var(--black) !important;
    }
  }
}
</style>